import Plan from "@mapmycustomers/shared/types/Plan";

import Feature, { ALL_FEATURES, featurePlanMap } from "@app/enum/Feature";
import SubscriptionPlan, { SUBSCRIPTION_PLAN_ORDER } from "@app/enum/SubscriptionPlan";
import findPlanTier from "@app/util/plans/findPlanTier";

import getFeatureCardState, { FeatureCardState } from "./getFeatureCardState";
import { AddOnServices } from "./isFeatureEnabled";

export interface SellableBand {
  features: Feature[];
  plan: SubscriptionPlan;
  planRow: Plan;
}

// The single answer to "what can this org buy". A band renders only when its plan row exists, it
// ranks strictly above the org's own tier, and at least one of its cards is available. The
// Features page and the user menu both read this, so the menu can never offer a page with no
// bands on it.
const getSellableBands = (
  addOnServices: AddOnServices,
  currentSubscriptionPlan: SubscriptionPlan | undefined,
  plans: Plan[]
): SellableBand[] => {
  const currentRank = currentSubscriptionPlan
    ? SUBSCRIPTION_PLAN_ORDER.indexOf(currentSubscriptionPlan)
    : -1;

  return SUBSCRIPTION_PLAN_ORDER.filter((_, rank) => rank > currentRank)
    .map((plan) => ({
      features: ALL_FEATURES.filter(
        (feature) =>
          featurePlanMap[feature] === plan &&
          getFeatureCardState(feature, addOnServices) === FeatureCardState.AVAILABLE
      ),
      plan,
      planRow: findPlanTier(plans, plan),
    }))
    .filter((band): band is SellableBand => !!band.planRow && band.features.length > 0);
};

export default getSellableBands;
